import { Controller, FieldValues } from "react-hook-form";
import { useTranslation } from "next-i18next";
import { convert, LocalDate } from "@js-joda/core";
import { ControlledFormInputProps } from "@talladega/types";
import { DatePicker } from "../DatePicker";

type Props<T extends FieldValues> = {
  required?: boolean;
} & ControlledFormInputProps<T>;

export const DiscountExpiryDatePicker = <TFormValues extends FieldValues>({
  errors,
  rules,
  required = false,
  ...props
}: Props<TFormValues>): JSX.Element => {
  const { t } = useTranslation(["common"]);
  const error = props.name ? errors?.[props.name] : undefined;

  const today = LocalDate.now();

  return (
    <Controller
      rules={{
        required: {
          value: required,
          message: t("common:required"),
        },
        ...rules,
      }}
      render={({ field: { onChange, value } }) => (
        <DatePicker
          feedback={error?.message?.toString()}
          status={error ? "error" : "default"}
          label={t("common:discount_expiry_date") || undefined}
          onChange={onChange}
          minDate={convert(today.plusDays(1)).toDate()}
          maxDate={convert(today.plusDays(90)).toDate()}
          selected={value}
        />
      )}
      {...props}
    />
  );
};

export default {};
